module.exports = __webpack_public_path__ + "static/media/john_doe.2ae861dd.png";